import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';

const ErrorComponent = () => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <div className={styles.content}>
        <p className={styles.title}>404</p>
        <p className={styles.description}>
          Упс...<br></br>
          Такої сторінки не існує.
        </p>
      </div>
    </div>
  );
};

export default ErrorComponent;
